import React from 'react'
import Navbar from '../layout/Navbar'
import img from "../assets/ceo-img.jpeg"
import { Helmet } from 'react-helmet'

const CeoPage = () => {
  return (
    <div id='message'>
      <Navbar />
      <Helmet>
        <title>Vwrap | Message From Our CEO</title>
        <meta name="description" content="To give you an idea of what skills Vwrap brings to the table and the philosophy behind our work, we bring you a message directly from our esteemed CEO." />
      </Helmet>
   <div id='ceo-div'>
   <h1 style={{color:'black',width:"100%",textAlign:"center"}}>CEO's Message</h1>
   <div id='ceo-div-1'>
        <img src={img} alt='vwrap'/>
      
      </div>

       <div id="ceo-div-2">
        <h1 id='commas'>"</h1>
        <p>
        As an Outdoor Media Agency (OMA) CEO, I bring extensive experience in creating innovative and effective advertising campaigns that capture attention and drive results. With a deep understanding of the unique challenges and opportunities in the OOH space, I have a proven track record of delivering high-impact campaigns that engage audiences and deliver measurable ROI.


With a keen eye for emerging trends and a passion for creative problem-solving, I am committed to staying at the forefront of the industry and leveraging the latest technology and techniques to deliver cutting-edge solutions. Whether it's developing immersive experiential activations, harnessing the power of data and analytics to optimize campaigns, or leveraging new media formats and platforms to reach audiences in innovative ways, I am constantly pushing the boundaries of what's possible in the OOH space.

As a collaborative and strategic leader, I believe in building strong and effective teams that are aligned around a common vision and mission to achieve what there is to be achieved.

        </p>
        <p id='ceo-name'>
          <b>
          - Maimoon Raza
          </b>
        </p>
       </div>
   </div>

    </div>
  )
}

export default CeoPage
